function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PaginationVue from '@/components/PaginationVue';
import search_engine_service from '@/apps/attributes/services/search_engine_service';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { mapState } from 'vuex';
import tasks from '@/js/tasks';
import { localPaginationMixin } from '@/mixins/local_pagination';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
export default {
  name: 'EditBlackListAttributes',
  components: {
    PaginationVue: PaginationVue,
    OrganizacionComponent: OrganizacionComponent
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  mixins: [localPaginationMixin],
  data: function data() {
    var perPage = 5;
    return {
      q: '',
      title: 'Add',
      list_orgs: [],
      attributesBlackList: [],
      keyTable: 0,
      tab: null,
      encontrado: {
        'found': 0,
        'page': 1,
        'per_page': perPage,
        'q': '',
        'search_time_ms': 0,
        'busqueda': []
      },
      filtro: {
        category: [],
        category_comma: '',
        q: '',
        per_page: perPage,
        page: 1,
        not_null_without_value: true,
        not_null_min: 0,
        not_null_max: 100,
        include_no_available: true
      },
      isLoading: false,
      attributes_edit: [],
      partitionsByTable: {},
      valid: true,
      pagination: {
        search: {
          current: 1,
          limit: perPage,
          total: 0
        }
      },
      BlackListItemsBase: [],
      domain: null,
      orgs: [],
      checkboxCategoryDenied: false,
      readonlyCheck: true
    };
  },
  beforeMount: function beforeMount() {
    this.getattributesBlackList();
    this.CalcEngine();
  },
  methods: {
    PreselectionData: function PreselectionData() {
      var _this = this;
      this.attributes_edit.forEach(function (a) {
        _this.editedIndex = _this.encontrado.busqueda.findIndex(function (item) {
          return item.categoria == a.categoria && item.nombre == a.nombre;
        });
        if (_this.editedIndex >= 0) {
          var b = _this.encontrado.busqueda[_this.editedIndex];
          b.status = true;
          _this.editedItem = Object.assign({}, b);
          Object.assign(_this.encontrado.busqueda[_this.editedIndex], _this.editedItem);
        }
      });
    },
    next: function next(page) {
      this.filtro.page = page;
      this.buscarTerminos();
      this.isLoading = false;
    },
    buscarTerminos: function buscarTerminos() {
      var _this2 = this;
      console.log('this.filtro');
      console.log(this.filtro);
      this.isLoading = true;
      search_engine_service.getBuscadorAtributos(this.filtro).then(function (response) {
        _this2.isLoading = false;
        _this2.encontrado = response;
        _this2.existeBusqueda = _this2.encontrado.found > 0;
        if (_this2.existeBusqueda) {
          _this2.encontrado.busqueda = _this2.encontrado.busqueda.map(function (v) {
            return _objectSpread(_objectSpread({}, v), {}, {
              status: false
            });
          });
          _this2.PreselectionData();
        } else {
          _this2.encontrado.busqueda = [];
        }
      });
    },
    sendToSearch: function sendToSearch() {
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      console.log('search');
      var category = this.item.alias;
      this.filtro.q = this.q;
      this.filtro.category = category;
      this.filtro.category_comma = category;
      if (this.q == null) {
        this.q = '';
      }
      this.buscarTerminos();
    },
    addAllItem: function addAllItem() {
      var _this3 = this;
      var counter = 0;
      this.encontrado.busqueda.forEach(function (item) {
        if (item.status === true) {
          counter++;
        }
      });
      if (counter < this.encontrado.busqueda.length) {
        this.encontrado.busqueda.forEach(function (item) {
          if (item.status === false) {
            item.status = true;
            _this3.addItem(item);
          }
        });
      } else {
        this.encontrado.busqueda.forEach(function (item) {
          _this3.removeItem(item);
          item.status = false;
        });
      }
    },
    editItem: function editItem(item) {
      this.editedIndex = this.encontrado.busqueda.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.status) {
        this.editedItem.status = false;
        this.removeItem(item);
      } else {
        this.editedItem.status = true;
        this.addItem(item);
      }
      Object.assign(this.encontrado.busqueda[this.editedIndex], this.editedItem);
    },
    addItem: function addItem(item) {
      var _this4 = this;
      if (item.company_code.includes(this.domain)) {
        item.company_code.splice(item.company_code.indexOf(this.domain), 1);
      }
      var records = [{
        attribute_group_id: this.item.id,
        name: item.nombre,
        company_code: this.domain
      }];
      var add = {
        records: records
      };
      UseCasesService.postAddAttributesBlackList(add).then(function (response) {
        var black = {
          nombre: item.nombre,
          categoria: item.categoria,
          company_code: item.company_code
        };
        search_engine_service.postUpdateAvailable(black).then(function (response) {
          tasks.toast.success('Actualizado correctamente!');
        });
        var elemento = {
          attribute_group_id: _this4.item.id,
          nombre: item.nombre,
          categoria: item.categoria,
          company_code: item.company_code
        };
        _this4.attributes_edit.push(elemento);
        _this4.attributesBlackList = _this4.attributes_edit;
      });
    },
    removeItem: function removeItem(item) {
      var _this5 = this;
      if (!item.company_code.includes(this.domain)) {
        item.company_code.push(this.domain);
      }
      // item.company_code
      var records = [{
        attribute_group_id: this.item.id,
        name: item.nombre,
        company_code: this.domain
      }];
      var eliminar = {
        records: records
      };
      UseCasesService.postDeleteAttributesBlackList(eliminar).then(function (response) {
        var black = {
          nombre: item.nombre,
          categoria: item.categoria,
          company_code: item.company_code
        };
        search_engine_service.postUpdateAvailable(black).then(function (response) {
          tasks.toast.success('Atributo liberado!');
        });
        var index = _this5.attributes_edit.findIndex(function (a) {
          return a.nombre == item.nombre && a.categoria == item.categoria;
        });
        _this5.attributes_edit.splice(index, 1);
      });
    },
    getattributesBlackList: function getattributesBlackList() {
      var _this6 = this;
      this.BlackListItemsBase = [];
      UseCasesService.getAttributesBlackList().then(function (response) {
        if (response && response.data) {
          Object.entries(response.data.attribute_source_id).forEach(function (entry) {
            var _entry = _slicedToArray(entry, 2),
              key = _entry[0],
              value = _entry[1];
            if (value.company_code === _this6.domain) {
              var especific = {
                q: value.name,
                category_comma: _this6.item.alias
              };
              search_engine_service.getBuscadorAtributosEspecifico(especific).then(function (rpta) {
                if (rpta) {
                  console.log('rpta');
                  console.log(rpta);
                  _this6.BlackListItemsBase.push({
                    id: key,
                    attribute_group_id: value.attribute_group_id,
                    nombre: value.name,
                    categoria: _this6.item.alias,
                    company_code: rpta.busqueda[0].company_code
                  });
                  _this6.attributes_edit = _this6.BlackListItemsBase.filter(function (item) {
                    return item.attribute_group_id === parseInt(_this6.item.id);
                  });
                  _this6.attributesBlackList = _this6.attributes_edit;
                }
              });
            }
          });
        }
      });
    },
    // onUpdate() {
    //   if (!this.$refs.form.validate()) {
    //     return
    //   }
    //   const rDetailAttributes = this.attributes_edit.map((item) => {
    //     return {
    //       attribute_name: item.nombre,
    //       attribute_object_name: item.tabla,
    //       attribute_scheme_name: item.dataset,
    //       attribute_project_name: item.proyecto,
    //       is_partyid: item.is_partyid || '0',
    //       is_external: item.is_external || '0',
    //       attribute_source_id: 3,
    //       attribute_filters: item.filters ? item.filters : {},
    //       attribute_description: item.descripcion,
    //       attribute_category: item.categoria,
    //       attribute_dtype: item.tipo_dato,
    //       attribute_notnull: item.no_nulo
    //     }
    //   })
    //   // Como se reemplaza toda la lista, se añaden los atrributos externos (Agregados de tablas de INCA o de tablas propias del Sandbox)
    //   const externalAttributes = this.useCase.attributes.filter((item) => item.is_external === '1')
    //   rDetailAttributes.push(...externalAttributes)
    //   const params = {
    //     company_name: this.companyName,
    //     append: false,
    //     flag_data_ext: '0',
    //     applicant: this.userEmail,
    //     // Solicitude id 4: Solicitud de añadido de atributos
    //     solicitude_type_id: 4,
    //     rdetail: rDetailAttributes
    //   }
    //   UseCasesService.updateAttributesUseCase(this.companyCode, this.useCase.id, false, params).then(response => {
    //     tasks.toast.success('Se está procediendo con la actualización.')
    //   }).catch((err) => {
    //     console.error(err)
    //     tasks.toast.error(this.translate('error_messages.error_general'), this.translate('titles.error'))
    //   }).finally(() => {
    //     this.$emit('close')
    //   })
    // },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    CalcEngine: function CalcEngine() {
      var _this7 = this;
      if (this.item.denied_company_code) {
        Object.entries(this.item.denied_company_code).forEach(function (entry) {
          var _entry2 = _slicedToArray(entry, 2),
            key = _entry2[0],
            value = _entry2[1];
          _this7.orgs.push(value);
        });
      }
    },
    changeDomian: function changeDomian() {
      this.readonlyCheck = false;
      this.checkboxCategoryDenied = this.orgs.includes(this.domain);
      this.getattributesBlackList();
    },
    changeCheck: function changeCheck() {
      var _this8 = this;
      var formElement = this.$refs.form;
      if (!formElement.validate()) {
        return;
      }
      if (this.orgs.includes(this.domain)) {
        this.orgs = this.orgs.filter(function (arrayItem) {
          return arrayItem !== _this8.domain;
        });
        // agregar los company_code a la coleccion del typesense
        // actualizarEmpresaCategoria(this.item.alias, 'adicionar', this.domain)
        search_engine_service.postActualizarEmpresaCategoria(this.item.alias, 'adicionar', this.domain).then(function (response) {});
      } else {
        this.orgs.push(this.domain);
        // quitar los company_code de la coleccion del typesense
        // actualizarEmpresaCategoria(this.item.alias, 'remover', this.domain)
        search_engine_service.postActualizarEmpresaCategoria(this.item.alias, 'remover', this.domain).then(function (response) {});
      }
      var denegados = {};
      for (var i = 0; i < this.orgs.length; i++) {
        denegados[i] = this.orgs[i];
      }
      console.log(denegados);
      this.item.denied_company_code = denegados;
      UseCasesService.patchEditAttributeMasterCatalog(this.item, this.item.id).then(function (response) {
        console.log(response);
        tasks.toast.success('Actualizado correctamente!');
      });
    },
    getListOrgsDetailed: function getListOrgsDetailed() {
      var _this9 = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          _this9.list_orgs = response.data;
        }
      });
    }
  },
  created: function created() {
    this.getListOrgsDetailed();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    rules: function rules() {
      var _this0 = this;
      return {
        domain: [function (v) {
          return !!v || _this0.translate('reglas.domain');
        }]
      };
    },
    headers: function headers() {
      return [{
        text: this.translate('attributes.search.table_search_list.name'),
        value: 'nombre'
      }, {
        text: this.translate('attributes.search.table_search_list.description'),
        value: 'descripcion'
      }, {
        text: this.translate('attributes.search.table_search_list.category'),
        value: 'categoria'
      }, {
        text: this.translate('attributes.search.table_search_list.data_type'),
        value: 'tipo_dato'
      }, {
        text: this.translate('attributes.search.table_search_list.percentage'),
        value: 'no_nulo'
      }, {
        text: '',
        value: 'actions'
      }];
    },
    headers2: function headers2() {
      return [{
        text: this.translate('attributes.search.table_search_list.name'),
        value: 'nombre'
      }, {
        text: '',
        value: 'actions'
      }];
    }
  })
};